<template>
  <div class="farm-window farm-list-card tasks-card" :style="cssVars">
    <h2>Staff Management</h2>
    <p style="margin: auto 0; text-align: right;">Let your employees know what to do.</p>
    <div class="farm-list">
      <template v-for="employee in farm.state.employees" v-bind:key="employee">
        <div class="farm-window farm-list-entry">
          <div class="option-buttons" style="height: 40px; grid-template-columns: 1fr 40px;">
            <h3>{{ employee.name }}
              <span style="font-weight: normal; font-size: 0.75em;">
                (<span>
                  <span v-for="(p, i) in employee.personalities" :title="p.description()">
                  {{ util.capitalize(p.id) }}<span v-if="i != employee.personalities.length - 1">&nbsp;</span>
                  </span>,
                </span>
                {{ employee.iq.value.toFixed(0) }} IQ, {{ employee.mood.text }})
              </span>
            </h3>
            <TextButton @click="employee.quit()"
                        class="farm-button exit-button"
                        :title="`Fire ${employee.name}`">
              <p>Fire</p>
            </TextButton>
          </div>
          <div class="option-buttons" style="height: 40px;">
            <TextButton @click="farm.assignWork(employee, 'office')"
                        class="farm-button"
                        :class="{'selected-button': employee.assignment === 'office'}"
                        :title="employee.name + ' will help you run the farm and increase milk price.'">
              <p>Office</p>
            </TextButton>

            <TextButton @click="farm.assignWork(employee, 'farm')"
                        class="farm-button"
                        :class="{'selected-button': employee.assignment === 'farm'}"
                        :title="employee.name + ' will focus on eating and sleeping well to produce more milk.'">
              <p>Pasture</p>
            </TextButton>
            <TextButton @click="farm.assignWork(employee, 'lab')"
                        class="farm-button"
                        :class="{'selected-button': employee.assignment === 'lab'}"
                        :title="employee.name + ' will use their intelligence to unlock new research quicker.'">
              <p>Lab</p>
            </TextButton>
          </div>
          <div class="option-buttons" style="height: 40px;" v-if="employee.assignment == 'office'">
            <TextButton class="farm-button"
                        :class="{'selected-button': employee.officeTask === 'milking'}"
                        @click="employee.officeTask = 'milking'">
              <p>Milking ({{ this.util.showNumber(employee.milkingSpeed * farm.state.milkingSpeed.value * 60) }} L/day)</p>
            </TextButton>
            <TextButton class="farm-button"
                        :class="{'selected-button': employee.officeTask === 'sales'}"
                        @click="employee.officeTask = 'sales'">
              <p>Advertise (demand {{ employee.milkConsumptionIncrease.toString() }})</p>
            </TextButton>
            <!--<TextButton class="farm-button"
                        :class="{'selected-button': employee.officeTask === 'budget'}"
                        @click="employee.officeTask = 'budget'">
              <p>Reduce Costs</p>
            </TextButton>-->
          </div>
        </div>
      </template>
      <template v-if="farm.state.employees.length < farm.state.staffLimit.max">
        <div class="farm-window farm-list-entry" :class="{'disabled-window': !farm.canHire}">
          <div class="option-buttons" style="height: 40px; grid-template-columns: 150px 1fr;">
            <h3>New employee
            </h3>
            <TextButton @click="farm.hire()"
                        class="farm-button"
                        :class="{'disabled-button': !farm.canHire}"
                        :title="`Hire`">
              <p v-if="farm.canHire">Hire (${{farm.hiringCost()}})</p>
              <p v-else-if="farm.state.employees.length < farm.state.staffLimit.value">Can't afford hiring (${{farm.hiringCost()}})</p>
              <p v-else>Research required to hire more staff</p>
            </TextButton>
          </div>
        </div>
      </template>
    </div>

  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Employee from '@/employee/Employee'
import Farm from '@/farm/Farm'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import TextButton from '@/components/ui/TextButton.vue'
import util from '@/util'

@Options({
  components: {
    ValueMeter, TextButton
  },
  props: {
    employee: Employee, farm: Farm
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    }
  },
  computed: {
    cssVars() {
      return {
        '--background-image': 'url(' + require('@/assets/wolfgang-hasselmann.jpg') + ')'
      }
    },
    util() {
      return util
    }
  }
})
export default class OfficeTasksCard extends Vue {
  farm!: Farm
}
</script>

<style scoped lang="scss">
  .tasks-card {
    min-height: 50vh;
    width: 100%;
    grid-template-columns: 1fr 1fr;
  }

  .farm-list {
    grid-area: c;

    overflow-y: auto;
  }

  .summary-card {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr;
    margin-bottom: 10px;

    h3 {
      grid-column: 1 / 5;
    }

    h4 {
      margin-left: 20px;
    }
  }

  .option-buttons {
    display: grid;
    grid-auto-columns: 1fr;
    grid-auto-flow: column;

    p {
      text-align: center;
    }

    .text-button {
      display: table;
      margin-top: auto;
      margin-bottom: auto;
      height: 80%;
      border: $component-border-style;
      border-right: 0;

      &:last-child {
        border: $component-border-style;
      }

      p {
        display: table-cell;
        vertical-align: middle;
      }
    }

    .selected-button {
      background-color: scale-color(darken($highlight-color, 10%), $saturation: -10%);
      //border-color: $highlight-color;
      p {
        //color: $highlight-color;
      }
    }
  }

</style>
